/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiSubscription, ApiSubscribe } from "../wire/ApiSubscriber";
import type { StickyTypeApiHandler } from "./Handler";
import {
  stickyTypeCreatedEventSchema,
  stickyTypeDeletedEventSchema,
  stickyTypeUpdatedEventSchema,
} from "./schemas";

export const subscribeStickyType: ApiSubscribe<StickyTypeApiHandler> = (
  subscriber,
  variables,
  handler,
) => {
  const subscriptions = new Array<ApiSubscription>();
  if (handler.stickyTypeCreated) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.sticky_type.v1.sessions.${sessionId}.sticky_type.created",
          variables,
          types: { sessionId: String },
        },
        stickyTypeCreatedEventSchema,
        handler.stickyTypeCreated,
        [],
      ),
    );
  }
  if (handler.stickyTypeUpdated) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.sticky_type.v1.sessions.${sessionId}.sticky_type.updated",
          variables,
          types: { sessionId: String },
        },
        stickyTypeUpdatedEventSchema,
        handler.stickyTypeUpdated,
        [],
      ),
    );
  }
  if (handler.stickyTypeDeleted) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.sticky_type.v1.sessions.${sessionId}.sticky_type.deleted",
          variables,
          types: { sessionId: String },
        },
        stickyTypeDeletedEventSchema,
        handler.stickyTypeDeleted,
        [],
      ),
    );
  }
  return subscriptions;
};
